import React from "react";
import "./style.css";

const Card = ({ data }) => {
  return (
    <div className="score-card card border-0 my-4">
      <div className="card-body">
        <div className="title d-flex align-items-center">
          <h5 className="card-title py-3 mb-0">{data?.category_name}</h5>
          <span className="fw-bold me-5 percent">{Math.ceil(data?.percentage)}%</span>
        </div>
        {data?.feedback && <>
          <p className="fw-bold text-start pe-3">{data?.feedback}</p>
          <p className="writer text-start">-{data?.editedBy}</p>
        </>
        }
        <div className="bottom-border mb-3"></div>
        <div className="row text-start">
          {data?.activity_wise?.map((res, key) => {
            return (<>
              <div className="col-6 col-lg-2" key={key}>
                <p className="hdng">{res?.name}</p>
              </div>
              <div className="col-6 col-lg-1">
                <p className="text">{res?.grade}</p>
              </div>
            </>)
          })}
        </div>
      </div>
    </div>
  );
};

export default Card;
